import React from 'react';
import useUser from '../hooks/useUser';
import OdcOrdersPage from './OdcOrdersPage';

const OdcList = () => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    return <OdcOrdersPage role={role} />;
};

export default OdcList;
